module.exports = __webpack_public_path__ + "static/media/logo-prefeitura-pomba.e06810c0.png";